module.exports = __webpack_public_path__ + "img/y_p2_minwu.f767c599.svg";